<template>
  <!-- new登录页 -->
  <div class="login_index">
    <div class="center" v-if="!isScanCode">
      <!-- <div class="c_left">
                终身学习，上进创新；团队协作，互利共荣！
            </div> -->
      <div class="c_right" v-if="!retrieve" v-loading="isDinglogin">
        <img @click="changeLogin()" src="../assets/images/login_change_1.png" class="l_t_btn">
        <div class="login_title">慧航后台系统</div>
        <div class="login_title_english lose_english">
          Welcome to log in HUIHANG System
        </div>
        <div class="input">
          <!-- <i class="iconfont icon-yonghu"></i> -->
          <el-input
            type="text"
            class="form-input"
            v-model="account"
            placeholder="请输入用户名"
            clearable
            validate-event
            autocomplete="off"
            maxlength="20"
            :disabled="telDisable"
            @blur="handleBlur"
          ></el-input>
          <div class="error-tip" v-if="!account">请输入用户名</div>
        </div>
        <div class="input" v-if="!isShowCode">
          <el-input
            type="text"
            v-if="!showPassword"
            autocomplete="off"
            class="form-input"
            :class="{input_password: password.length > 0}"
            placeholder="请输入密码"
            v-model="password"
            minlength="6"
            validate-event
            @input="changeBlur"
          >
            <img
              @click="showPassword = !showPassword"
              slot="suffix"
              src="https://appfile2.sbgw.cn/hhxt/c048167e46c947a1b42cef41655ce92b.png"
              alt=""
            />
          </el-input>
          <el-input
            type="text"
            autocomplete="off"
            v-else
            class="form-input"
            placeholder="请输入密码"
            v-model="password"
            minlength="6"
            validate-event
            @input="changeBlur"
          >
            <img
              slot="suffix"
              @click="showPassword = !showPassword"
              src="https://appfile2.sbgw.cn/hhxt/2a394efda4294d71931c7a9602a39e10.png"
              alt=""
            />
          </el-input>
          <div class="error-tip" v-if="!isShowCode">{{!password?'请输入密码':passwordShow?'请输入8-20位,英文和数字字符':''}}</div>
        </div>
        <div class="input" v-if="isShowCode">
          <el-input
            type="text"
            v-model="loginVerificationCode"
            placeholder="请输入手机短信验证码"
            clearable
            oninput="this.value = this.value.replace(/[^0-9]/g, '');"
            auto-complete="off"
          >
            <el-button
              v-if="!loginSendSuccess"
              slot="suffix"
              :disabled="loginCodeDisabled"
              class="validation pointer"
              style="color: #ffd71d; font-weight: 600; border: none"
              @click="clickLoginValidation"
              >获取验证码</el-button
            >
            <el-button
              disabled
              v-if="loginSendSuccess"
              slot="suffix"
              class="validation pointer"
              style="border: none"
              >{{ loginCount }}s</el-button
            >
          </el-input>
          <el-popover
            class="item_popover"
            placement="right"
            title="验证码说明"
            :width="350"
            trigger="hover"
          >
            <div>
              点击获取验证码后：系统会自动向当前登陆帐号关联的手机号推送短信消息，请注意查收！<br />如需调整或查看当前登陆帐号关联的手机号，请联系直属上级在后台[管理员设置]中操作
            </div>
            <template #reference>
              <el-button type="warning" plain>
                <span class="item_btn"> <i class="el-icon-warning"></i> 说明 </span>
              </el-button>
            </template>
          </el-popover>
          <div class="error-tip" v-if="!loginVerificationCode">请输入验证码</div>
        </div>
        <el-button
          class="submit-btn"
          :class="{ isClickLogin: isClickLogin }"
          type="primary"
          :disabled="isSubmitDisabled || isClickLogin"
          @click="submitClick"
          @keyup.enter="keyDown(e)"
          >{{ isClickLogin ? "登录中..." : "登录" }}</el-button
        >
        <div @click="losePassword" class="oth-switch">忘记密码?</div>
      </div>
      <!-- 忘记密码 -->
      <div class="c_right lose_right" v-if="retrieve" v-loading="isDinglogin">
        <!-- <div class="flex title">
                    <h3 class="lose-title">忘记密码</h3>
                    <div class="lose-titleLogin pointer" @click="clickNext2('isLogin')">
                        登录<i class="iconfont icon-fangxiangjiantou-you"></i>
                    </div>
                </div> -->
        <div class="login_title">慧航后台系统</div>
        <div class="login_title_english lose_english">
          Welcome to log in HUIHANG System
        </div>
        <el-form
          ref="RetrievePassword"
          :inline="true"
          :model="RetrievePassword"
          :rules="rules"
          label-width="140px"
          label-position="left"
          id="form-sure"
          style="color: #333"
        >
          <el-form-item
            label="手机号码"
            class="input-box"
            prop="telPhone"
            style="background: #fff"
          >
            <div class="adress-box">
              <div class="adress">
                <div style="margin-right: 5px" @click="show">
                  {{ code }}
                  <!-- <i class="iconfont icon-xiangxiajiantou"></i> -->
                  <!-- <img
                    src="../assets/images/drop_down.png"
                  /> -->
                </div>
                <ul v-show="isShow">
                  <li
                    class="flex"
                    style="width: 200px; justify-content: space-between"
                    v-for="(item, index) in arr"
                    :key="index"
                    @click="handleCommand(item.code)"
                  >
                    <div>{{ item.code }}</div>
                    <div>{{ item.name }}</div>
                  </li>
                </ul>
              </div>
            </div>
            <el-input
              v-model="RetrievePassword.telPhone"
              placeholder="注册时填写的手机号"
              clearable
              :class="{'disable-color': isDisableRetrieveTel}"
              :disabled="isDisableRetrieveTel"
            >
            </el-input>
          </el-form-item>
          <el-form-item
            class="input-box"
            prop="selectUser"
            style="background: #fff"
            v-if="isMultiAccountUser"
          >
            <template #label>
              <div class="account_parent">
                  <div class="account_child" 
                     @click="showSelectAccount = !showSelectAccount"
                  >
                    <span>选择账号</span>  
                      <img
                        src="../assets/images/drop_down.png"
                        alt="下拉箭头"
                        title="下拉箭头"
                      />
                  </div>
                  <ul class="select-user" v-if="showSelectAccount">
                    <li
                      class="flex user-list list-item"
                      style="justify-content: space-between"
                      v-for="item in usersAccount"
                      :key="item.id"
                      @click="handleSelectAccount(item.id)"
                    >
                      <div>{{ item.name }}（{{ item.roleName }}）</div>
                    </li>
                  </ul>
              </div>
            </template>
        
            <el-input
              placeholder="请选择需要更改密码的账号"
              class="select-user-input"
              clearable
              @focus="displaySelectAccount"
              :value="currentSelectUser"
            ></el-input>
          </el-form-item>
          <el-form-item label="短信验证码" class="input-box" prop="VerificationCode">
            <el-input
              v-model="RetrievePassword.VerificationCode"
              placeholder="请填写短信验证码"
              clearable
              oninput="this.value = this.value.replace(/[^0-9]/g, '');"
            >
              <el-button
                v-if="!SendSuccess"
                slot="suffix"
                :disabled="codeDisabled"
                class="validation pointer"
                style="color: #ffd71d; font-weight: 600; border: none"
                @click="clickValidation(RetrievePassword.telPhone, 'RetrievePassword')"
                >获取验证码</el-button
              >
              <el-button
                disabled
                v-if="SendSuccess"
                slot="suffix"
                class="validation pointer"
                style="border: none"
                >{{ count }}s</el-button
              >
            </el-input>
          </el-form-item>
          <el-form-item label="设置密码" class="input-box" prop="passWord">
            <el-input
              v-if="!showResetPassword"
              type="text"
              :class="{ input_password: RetrievePassword.passWord && RetrievePassword.passWord.length > 0 }"
              v-model="RetrievePassword.passWord"
              placeholder="8-16位必须包含数字和字母"
              clearable
            >
            <img
              @click="showResetPassword = !showResetPassword"
              slot="suffix"
              src="https://appfile2.sbgw.cn/hhxt/c048167e46c947a1b42cef41655ce92b.png"
              alt=""
            />
            </el-input>
            <el-input
              v-else
              type="text"
              v-model="RetrievePassword.passWord"
              placeholder="8-16位必须包含数字和字母"
              clearable
            >
            <img
              slot="suffix"
              @click="showResetPassword = !showResetPassword"
              src="https://appfile2.sbgw.cn/hhxt/2a394efda4294d71931c7a9602a39e10.png"
              alt=""
            />
            </el-input>
          </el-form-item>
        </el-form>
        <el-button
          class="submit-sureBtn"
          :disabled="disabled"
          type="primary"
          @click="clickNext1('RetrievePassword')"
          @keyup.enter="keyDown(e)"
          >{{ disabled ? "提交中..." : "确认修改" }}</el-button
        >
        <div class="lose-titleLogin pointer" @click="clickNext2('isLogin')">返回登录</div>
      </div>
    </div>
    <div class="center" v-else>
      <div class="c_right c_right2" v-loading="isDinglogin">
        <img @click="changeLogin2()" src="../assets/images/login_change_2.png" class="l_t_btn">
        <div class="login_title">慧航后台系统</div>
        <div class="login_title_english lose_english">
          Welcome to log in HUIHANG System
        </div>
        <div class="admin_box" v-if="isScanCodeImg">
          <div class="admin_box_h" :class="it.length == 1?'pa_178':it.length == 2?'pa_89':''" v-for="(it,i) in adminListGroup" :key="i">
            <div class="admin_list hand" @click="handleAdminLogin(item)"  v-for="(item, index) in it" :key="index">
              <img v-if="item.logoPath" :src="item.logoPath" alt="管理员头像" class="admin_list_img">
              <div v-else class="admin_img_box">{{ item.name?item.name.slice(-2):'未设置'}}</div>
              <div class="admin_list_name">{{ item.name || '未设置'}}</div>
              <div class="admin_list_role">（{{ item.roleName || '未设置'}}）</div>
            </div>
          </div>
        </div>
        <div class="code_tip" v-if="isScanCodeImg">选择您需要登录的账户</div>
        <div id="login_container" class="login_container" v-if="!isScanCodeImg"></div>
        <!-- <div class="code_tip2" v-if="!isScanCodeImg">
          请使用钉钉扫描二维码登录
          <span class="code_tip_span hand" @click="changeLogin()">
            <i class="el-icon-refresh"></i>
            刷新</span>
        </div> -->
      </div>
      
     
    </div>
  </div>
</template>

<script>
import {
  logIn,
  logIn1,
  saveloginInfo,
  loginRoleInformation,
  GetCodeByTelPhone,
  GetAdminListForWeb,
  ResetPassword,
  SendMsgTelResponseTo,
  IsReLoginFromUserName,
  GetDingTalkCode,
  GetAdminList,
  DingLogin,
} from "network/login";
import { isNull, validateTel, hexToRgb,nameBrowser } from "../common/utils.js";
const version = require("element-ui/package.json").version; // element-ui version from node_modules
const ORIGINAL_THEME = "#409EFF"; // default color
import { defaultColor, defaultThemeStyle } from "common/const";
export default {
  name: "Login",
  props: {
    allConfig: {
      type: Object,
      default: () => {},
    },
    hasKey: {
      type: String,
      default: "",
    },
  },
  // 定义属性
  data() {
    // 不为空
    var validateNull = (rule, value, callback) => {
      if (isNull(value)) {
        return callback(new Error("请输入验证码！"));
      } else {
        callback();
      }
    };
    var validatePass = (rule, value, callback) => {
      if (isNull(value)) {
        return callback(new Error("请输入密码！"));
      } else if (
        (value && value.length < 8) ||
        !/^(?!^\d+$)(?!^[a-zA-Z]+$)[0-9a-zA-Z]{4,23}$/.test(value)
      ) {
        return callback(new Error("字符不小于8位的数字加字母"));
      } else {
        callback();
      }
    };
    const validateSelectUser = (rule, value, callback) => {
      
      if (isNull(this.RetrievePassword.id) || (typeof this.RetrievePassword.id === 'number' && this.RetrievePassword.id < 0)) {
        return callback(new Error("请选择需要更改密码的账号"));
      }  else {
        callback();
      }
    };
    return {
      isShow: false,
      name: "中国",
      code: "+86",
      isScanCode:false,
      passwordShow:true,
      arr: [
        {
          name: "阿尔巴尼亚",
          code: "+355",
        },
        {
          name: "阿尔及利亚",
          code: "+213",
        },
        {
          name: "阿富汗",
          code: "+93",
        },
        {
          name: "阿根廷",
          code: "+54",
        },
        {
          name: "阿拉斯加",
          code: "+1907",
        },
        {
          name: "阿鲁巴岛",
          code: "+297",
        },
        {
          name: "阿曼",
          code: "+968",
        },
        {
          name: "阿森松",
          code: "+247",
        },
        {
          name: "埃及",
          code: "+20",
        },
        {
          name: "埃塞俄比亚",
          code: "+251",
        },
        {
          name: "爱尔兰",
          code: "+353",
        },
        {
          name: "安哥拉",
          code: "+244",
        },
        {
          name: "安圭拉岛",
          code: "+1809",
        },
        {
          name: "奥地利",
          code: "+43",
        },
        {
          name: "澳大利亚",
          code: "+61",
        },
        {
          name: "巴巴多斯",
          code: "+1809",
        },
        {
          name: "巴哈马",
          code: "+1809",
        },
        {
          name: "巴基斯坦",
          code: "+92",
        },
        {
          name: "巴拉圭",
          code: "+595",
        },
        {
          name: "巴林",
          code: "+973",
        },
        {
          name: "巴拿马",
          code: "+507",
        },
        {
          name: "巴西",
          code: "+55",
        },
        {
          name: "保加利亚",
          code: "+359",
        },
        {
          name: "贝宁",
          code: "+229",
        },
        {
          name: "比利时",
          code: "+32",
        },
        {
          name: "冰岛",
          code: "+354",
        },
        {
          name: "波多黎各",
          code: "+1809",
        },
        {
          name: "波兰",
          code: "+48",
        },
        {
          name: "玻利维亚",
          code: "+591",
        },
        {
          name: "伯利兹",
          code: "+501",
        },
        {
          name: "博茨瓦纳",
          code: "+267",
        },
        {
          name: "不丹",
          code: "+975",
        },
        {
          name: "布基拉法索",
          code: "+226",
        },
        {
          name: "布隆迪",
          code: "+257",
        },
        {
          name: "朝鲜",
          code: "+850",
        },
        {
          name: "赤道几内亚",
          code: "+240",
        },
        {
          name: "丹麦",
          code: "+45",
        },
        {
          name: "德国",
          code: "+49",
        },
        {
          name: "东萨摩亚",
          code: "+684",
        },
        {
          name: "多哥",
          code: "+228",
        },
        {
          name: "俄罗斯",
          code: "+7",
        },
        {
          name: "厄瓜多尔",
          code: "+593",
        },
        {
          name: "法国",
          code: "+33",
        },
        {
          name: "法罗群岛",
          code: "+298",
        },
        {
          name: "法属圭亚那",
          code: "+594",
        },
        {
          name: "梵蒂冈",
          code: "+396",
        },
        {
          name: "菲律宾",
          code: "+63",
        },
        {
          name: "斐济",
          code: "+679",
        },
        {
          name: "芬兰",
          code: "+358",
        },
        {
          name: "佛得角",
          code: "+238",
        },
        {
          name: "福克兰群岛",
          code: "+500",
        },
        {
          name: "冈比亚",
          code: "+220",
        },
        {
          name: "刚果",
          code: "+242",
        },
        {
          name: "哥伦比亚",
          code: "+57",
        },
        {
          name: "哥斯达黎加",
          code: "+506",
        },
        {
          name: "格陵兰岛",
          code: "+299",
        },
        {
          name: "古巴",
          code: "+53",
        },
        {
          name: "关岛",
          code: "+671",
        },
        {
          name: "圭亚那",
          code: "+592",
        },
        {
          name: "海地",
          code: "+509",
        },
        {
          name: "韩国",
          code: "+82",
        },
        {
          name: "荷兰",
          code: "+31",
        },
        {
          name: "洪都拉斯",
          code: "+504",
        },
        {
          name: "基里巴斯",
          code: "+686",
        },
        {
          name: "吉布提",
          code: "+253",
        },
        {
          name: "几内亚",
          code: "+224",
        },
        {
          name: "几内亚比绍",
          code: "+245",
        },
        {
          name: "加拿大",
          code: "+1",
        },
        {
          name: "加纳",
          code: "+233",
        },
        {
          name: "加蓬",
          code: "+241",
        },
        {
          name: "柬埔寨",
          code: "+855",
        },
        {
          name: "津巴布韦",
          code: "+263",
        },
        {
          name: "喀麦隆",
          code: "+237",
        },
        {
          name: "卡塔尔",
          code: "+974",
        },
        {
          name: "科科斯岛",
          code: "+6722",
        },
        {
          name: "科克群岛",
          code: "+682",
        },
        {
          name: "科摩罗",
          code: "+269",
        },
        {
          name: "科特迪瓦",
          code: "+225",
        },
        {
          name: "科威特",
          code: "+965",
        },
        {
          name: "肯尼亚",
          code: "+254",
        },
        {
          name: "莱索托",
          code: "+266",
        },
        {
          name: "老挝",
          code: "+856",
        },
        {
          name: "黎巴嫩",
          code: "+961",
        },
        {
          name: "利比里亚",
          code: "+231",
        },
        {
          name: "利比亚",
          code: "+218",
        },
        {
          name: "列支敦士登",
          code: "+4175",
        },
        {
          name: "留尼旺岛",
          code: "+262",
        },
        {
          name: "卢森堡",
          code: "+352",
        },
        {
          name: "卢旺达",
          code: "+250",
        },
        {
          name: "罗马尼亚",
          code: "+40",
        },
        {
          name: "马达加斯加",
          code: "+261",
        },
        {
          name: "马尔代夫",
          code: "+960",
        },
        {
          name: "马耳他",
          code: "+356",
        },
        {
          name: "马拉维",
          code: "+265",
        },
        {
          name: "马来西亚",
          code: "+60",
        },
        {
          name: "马里",
          code: "+223",
        },
        {
          name: "马提尼克",
          code: "+596",
        },
        {
          name: "毛里求斯",
          code: "+230",
        },
        {
          name: "毛里塔尼亚",
          code: "+222",
        },
        {
          name: "美国",
          code: "+1",
        },
        {
          name: "蒙古",
          code: "+976",
        },
        {
          name: "孟加拉国",
          code: "+880",
        },
        {
          name: "秘鲁",
          code: "+51",
        },
        {
          name: "缅甸",
          code: "+95",
        },
        {
          name: "摩洛哥",
          code: "+210",
        },
        {
          name: "莫桑比克",
          code: "+258",
        },
        {
          name: "墨西哥",
          code: "+52",
        },
        {
          name: "纳米比亚",
          code: "+264",
        },
        {
          name: "南非",
          code: "+27",
        },
        {
          name: "南斯拉夫",
          code: "+338",
        },
        {
          name: "瑙鲁",
          code: "+674",
        },
        {
          name: "尼加拉瓜",
          code: "+505",
        },
        {
          name: "尼泊尔",
          code: "+977",
        },
        {
          name: "尼日尔",
          code: "+227",
        },
        {
          name: "尼日利亚",
          code: "+234",
        },
        {
          name: "纽埃岛",
          code: "+683",
        },
        {
          name: "挪威",
          code: "+47",
        },
        {
          name: "诺福克岛",
          code: "+6723",
        },
        {
          name: "葡萄牙",
          code: "+351",
        },
        {
          name: "普林西比",
          code: "+239",
        },
        {
          name: "日本",
          code: "+81",
        },
        {
          name: "瑞典",
          code: "+46",
        },
        {
          name: "瑞士",
          code: "+41",
        },
        {
          name: "萨尔瓦多",
          code: "+503",
        },
        {
          name: "塞拉利昂",
          code: "+232",
        },
        {
          name: "塞内加尔",
          code: "+221",
        },
        {
          name: "塞浦路斯",
          code: "+357",
        },
        {
          name: "塞舌尔",
          code: "+248",
        },
        {
          name: "沙特阿拉伯",
          code: "+966",
        },
        {
          name: "圣诞岛",
          code: "+6724",
        },
        {
          name: "圣多美",
          code: "+239",
        },
        {
          name: "圣赫勒拿",
          code: "+290",
        },
        {
          name: "圣卢西亚",
          code: "+1809",
        },
        {
          name: "圣马力诺",
          code: "+223",
        },
        {
          name: "斯里兰卡",
          code: "+94",
        },
        {
          name: "斯威士兰",
          code: "+268",
        },
        {
          name: "苏丹",
          code: "+249",
        },
        {
          name: "苏里南",
          code: "+597",
        },
        {
          name: "所罗门群岛",
          code: "+677",
        },
        {
          name: "索马里",
          code: "+252",
        },
        {
          name: "泰国",
          code: "+66",
        },
        {
          name: "坦桑尼亚",
          code: "+255",
        },
        {
          name: "汤加",
          code: "+676",
        },
        {
          name: "突尼斯",
          code: "+216",
        },
        {
          name: "图瓦卢",
          code: "+688",
        },
        {
          name: "土耳其",
          code: "+90",
        },
        {
          name: "瓦努阿图",
          code: "+678",
        },
        {
          name: "危地马拉",
          code: "+502",
        },
        {
          name: "威克岛",
          code: "+1808",
        },
        {
          name: "维尔京群岛",
          code: "+1809",
        },
        {
          name: "委内瑞拉",
          code: "+58",
        },
        {
          name: "文莱",
          code: "+673",
        },
        {
          name: "乌干达",
          code: "+256",
        },
        {
          name: "乌拉圭",
          code: "+598",
        },
        {
          name: "希腊",
          code: "+30",
        },
        {
          name: "西班牙",
          code: "+34",
        },
        {
          name: "西萨摩亚",
          code: "+685",
        },
        {
          name: "夏威夷",
          code: "+1808",
        },
        {
          name: "新加坡",
          code: "+65",
        },
        {
          name: "新西兰",
          code: "+64",
        },
        {
          name: "匈牙利",
          code: "+336",
        },
        {
          name: "叙利亚",
          code: "+963",
        },
        {
          name: "牙买加",
          code: "+1809",
        },
        {
          name: "伊拉克",
          code: "+964",
        },
        {
          name: "伊朗",
          code: "+98",
        },
        {
          name: "以色列",
          code: "+972",
        },
        {
          name: "意大利",
          code: "+39",
        },
        {
          name: "印度",
          code: "+91",
        },
        {
          name: "印度尼西亚",
          code: "+62",
        },
        {
          name: "英国",
          code: "+44",
        },
        {
          name: "约旦",
          code: "+962",
        },
        {
          name: "越南",
          code: "+84",
        },
        {
          name: "赞比亚",
          code: "+260",
        },
        {
          name: "扎伊尔",
          code: "+243",
        },
        {
          name: "乍得",
          code: "+235",
        },
        {
          name: "直布罗陀",
          code: "+350",
        },
        {
          name: "智利",
          code: "+56",
        },
        {
          name: "中非",
          code: "+236",
        },
        {
          name: "中国",
          code: "+86",
        },
        {
          name: "中国澳门",
          code: "+853",
        },
        {
          name: "中国台湾",
          code: "+886",
        },
        {
          name: "中国香港",
          code: "+852",
        },
        {
          name: "中途岛",
          code: "+1808",
        },
      ],
      account: "",
      password: "",
      loginVerificationCode: "", //登录验证码
      loginCode: true, //登录验证码
      loginSendSuccess: false, //登录验证码发送成功
      loginCodeDisabled: false, //登录验证码按钮隐藏
      loginCount: 60, //登录倒计时
      isClickLogin: false,
      next: 1,
      // 重置密码前置条件
      RetrievePassword: {
        telPhone: "",
        VerificationCode: "",
        id: null,
        passWord: null,
      },
      // 该用户的所有账号
      usersAccount: [],
      // 是否显示选择账号
      showSelectAccount: false,
      currentSelectUser: '',
      isMultiAccountUser: false,
      // 修改密码
      tableMaxHeight: 140,
      retrieve: false,
      adminInfo: [],
      rules: {
        telPhone: [
          {
            require: true,
            validator: validateTel,
            trigger: ["blur", "change"],
          },
        ],
        VerificationCode: [
          {
            require: true,
            validator: validateNull,
            trigger: ["blur", "change"],
          },
        ],
        passWord: [
          {
            require: true,
            validator: validatePass,
            trigger: ["blur", "change"],
          },
        ],
        selectUser: [
          {
            require: true,
            validator: validateSelectUser,
            message: "请选择需要更改密码的账号",
            trigger: ["blur", "change"],
          },
        ]
      },
      rules1: {},
      isAdminList: false,
      SendSuccess: false, //发送成功
      count: 60,
      radio: null,
      allConfigAll: {},
      adminId: -1,
      showPassword: false,
      disabled: false,
      codeDisabled: false,
      telDisable: false,
      isShowCode:false,
      isCheck:false,
      showResetPassword: false,
      isClickCode1:false,
      isClickCode2:false,
      isDisableRetrieveTel:false,
      adminList:[
      ],
      adminListGroup:[],
      dingCode:'',
      isDinglogin:false,
      isScanCodeImg:false,
      // 钉钉登录相关数据
      dingLoginData: null,
      themeMenuId: null,
      selectedAdmin: null,
      // 主题更新消息实例，用于管理持久消息的关闭
      currentThemeMessageInstance: null,
    };
  },
  computed: {
    isSubmitDisabled() {
      if(this.isShowCode){
        return this.account.length > 0 &&
        (this.isShowCode ? this.loginVerificationCode.length > 0 : true)
        ? false
        : true;
      }else{
        return this.account.length > 0 &&
        this.password && this.password.length >= 8&&
      /^(?!^\d+$)(?!^[a-zA-Z]+$)[0-9a-zA-Z]{4,23}$/.test(this.password) &&
        (this.isShowCode ? this.loginVerificationCode.length > 0 : true)
        ? false
        : true;
      }
      
    },
    valideTel() {
      // 手机号正则
      const validateTel = /^1[3456789]\d{9}$/;
      return this.account && !validateTel.test(this.account);
    },
    isLargeScreen() {
      return sessionStorage.getItem('isLargeScreen') || false;
    },
    largeScreenPath(){
      return sessionStorage.getItem('largeScreenPath') || '';
    }
  },
  watch: {
    allConfig(newVal) {
      if (newVal) {
        this.allConfigAll = newVal;
      }
    },
  },
  created() { 
    if (!this.hasKey) {
      const defaultUrl = 'https://sb.hbzsb.cn/';
      let sessionCache = null;
      sessionCache = JSON.parse(sessionStorage.getItem('AdminCache'));
      const rawUrl = sessionCache?.centerAdminUrl || defaultUrl;
      const centerAdminUrl = rawUrl?.trim() || defaultUrl;
      const logoutUrl = `${centerAdminUrl}?logOut=true`;
      this.$alert(`您的登录信息已失效，请从升本中心 ${centerAdminUrl} 登录当前系统`, "提示", {
        confirmButtonText: "去登录",
        closeOnClickModal: false,
        closeOnPressEscape: false,
        showClose: false,
        callback: () => {
          window.location.replace(logoutUrl);
        },
      });
      return
    }
  },
  mounted() {

    this.$nextTick(() => {
      this.allConfigAll =
        this.$store.state.allConfig || JSON.parse(sessionStorage.getItem("allConfig"));
    });
    window.addEventListener("keydown", this.keyDown);

    // 检查钉钉登录数据
    // 获取URL参数
    const url = new URL(window.location.href);
    const params = new URLSearchParams(url.search);
    
    // 优先从sessionStorage获取已保存的钉钉登录数据
    const existingDingData = sessionStorage.getItem('dingLoginData');
    if (existingDingData) {
      this.dingLoginData = JSON.parse(existingDingData);
    } else {
      // 如果sessionStorage中没有数据，再从URL参数获取
      const fromDing = params.get('fromDing');
      const themenuid = params.get('themenuid');
      if (fromDing === 'true' && themenuid) {
        // 保存钉钉登录参数到组件数据和sessionStorage
        this.dingLoginData = {
          fromDingLogin: true,
          themeMenuId: themenuid
        };
        sessionStorage.setItem('dingLoginData', JSON.stringify(this.dingLoginData));
      }
    }
    
    // 获取 扫码登录 特定的参数值
    let param1 = params.get('code'); // 返回 'value1'
    if(param1){
      this.dingCode = param1
      this.getDIngAdminList(param1)
      // 清除URL中的code参数，避免页面刷新时重复处理
      const baseUrl = window.location.origin + window.location.pathname;
      window.history.replaceState({}, document.title, baseUrl + '#/');
    } else {
      // 如果没有钉钉登录数据和扫码参数，检查是否需要自动显示管理员选择
      this.checkAutoShowAdminList();
    }
     if (typeof window.addEventListener != 'undefined') {
          window.addEventListener('message', this.handleMessage, false);
      } else if (typeof window.attachEvent != 'undefined') {
          window.attachEvent('onmessage', this.handleMessage);
      }
  },
  beforeDestroy() {
    // 清理主题更新消息实例
    if (this.currentThemeMessageInstance && this.currentThemeMessageInstance.close) {
      this.currentThemeMessageInstance.close();
      this.currentThemeMessageInstance = null;
    }
    
    // 移除事件监听器
    if (typeof window.removeEventListener != 'undefined') {
      window.removeEventListener('message', this.handleMessage, false);
    } else if (typeof window.detachEvent != 'undefined') {
      window.detachEvent('onmessage', this.handleMessage);
    }
    
    // 移除键盘事件监听器
    window.removeEventListener("keydown", this.keyDown);
  },
  methods: {
    // 处理管理员登录
    async handleAdminLogin(item) {
      // 如果是从钉钉页面跳转过来的（toPageKnowledge.vue），使用管理员ID登录
      if (this.dingLoginData && this.dingLoginData.fromDingLogin) {
        // 使用管理员ID登录方式
        await this.adminDirectLogin(item);
      } else if (this.dingLoginData) {
        // 使用钉钉登录数据进行登录
        await this.performDingLogin(item);
      } else if (this.dingCode) {
        // 扫码登录
        await this.dingLogin(item);
      } else {
        // 普通管理员登录，直接使用管理员信息登录
        await this.adminDirectLogin(item);
      }
    },
    // 管理员直接登录
    async adminDirectLogin(admin) {
      if (this.isDinglogin) {
        return false;
      }
      
      this.isDinglogin = true;
      
      try {
        // 使用logIn1 API进行管理员登录
        const res = await logIn1('adminidlogin', 'huihang-admin', 'zsb.web.secret', admin.id);
        if (res.data.code == 1 && res.data.result && res.data.result.access_token) {
          this.isDinglogin = false;
          const data = res.data.result;
          let expiresTime = data.expires_in + new Date() / 1000;
          const token = {
            AccessToken: data.access_token,
            AccessExpiresIn: expiresTime,
            RefreshToken: data.refresh_token,
          };
          this.$store.commit("saveTokenStorage", token);
          this.getInfo(token);
        } else {
          this.isDinglogin = false;
          this.$alert(res.message || '登录失败，请重试');
        }
        
      } catch (error) {
        this.isDinglogin = false;
        console.error('管理员登录失败:', error);
      }
    },
    // 钉钉登录
    async dingLogin(item){
      // 如果是从 sessionStorage 传递的数据，使用新的登录方法
      if (this.dingLoginData) {
        await this.performDingLogin(item);
        return;
      }
      
      // 原有的扫码登录逻辑
      if(this.isDinglogin){
        return false
      }
      this.isDinglogin = true;
      let userAgent = nameBrowser();
      let obj = {
        code: this.dingCode,
        adminId:item?.id || null,
        userAgent: userAgent
      }
       // 检查是否为大屏登录
      if (this.isLargeScreen === 'true') {
          obj.isLargeScreen = true;
        }
      let res = await DingLogin(obj)
      if (res.status === 200 && res?.data?.code == 1 && res?.data?.result?.access_token) {
        this.isDinglogin = false;
        const data = res.data.result;
        let expiresTime = data.expires_in + new Date() / 1000;
        const token = {
          AccessToken: data.access_token,
          AccessExpiresIn: expiresTime,
          RefreshToken: data.refresh_token,
        };
        this.$store.commit("saveTokenStorage", token);
        this.getInfo(token);
      } else if(res?.data?.code == 1 && this.largeScreenPath && this.isLargeScreen == 'true'){
          this.toLargeScreen()
          return;
        }
      else {
        this.isDinglogin = false;
        
        this.$confirm(res.data.message || '登录失败', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          var url = window.location.origin + window.location.pathname;
          window.location.replace(url + '#/');
        }).catch(() => {
          var url = window.location.origin + window.location.pathname;
          window.location.replace(url + '#/');       
        });
       
      }

    },
    toLargeScreen(){
        // 清除大屏标识
        sessionStorage.setItem('isLogin','true');
        sessionStorage.removeItem('largeScreenPath');
        // 跳转回原大屏页面
        let largeScreenUrl = '/#' + this.largeScreenPath
        window.open(largeScreenUrl, "_self");
    },
    async getDIngAdminList(param1){
      if(this.isDinglogin){
        return false
      }
      let params = {code:param1};
      // 检查是否为大屏设备
      if (this.isLargeScreen === 'true') {
        params.isLargeScreen = true;
      }
      this.isDinglogin = true;
      let res = await GetAdminList(params)
      this.isDinglogin = false;
      this.isScanCodeImg = true
      if(res.data.code == 1){
        if(res.data.result && res.data.result?.length>0){
          this.isScanCode = true
          this.adminListGroup = this.group(res.data.result, 3) 
          if(res.data.result.length == 1){
            this.dingLogin(res.data.result[0])
          }
        }else{
          this.dingLogin()
        }
      }else{
        this.$alert(res.data.message)
        // var url = window.location.origin + window.location.pathname;
        // window.location.replace(url);
        return false
      }

    },
    // 切换登录方式
    changeLogin(){
      this.getDingTalkCode()
    },
    changeLogin2(){
      // 重置状态
      this.isScanCode = false;
      this.isScanCodeImg = false;
      this.dingCode = '';
      this.adminListGroup = [];
      this.selectedAdmin = null;
      // 隐藏 login_container
      document.getElementById("login_container").style.display = "none";
      // 清除 URL 中的 code 参数
      const baseUrl = window.location.origin + window.location.pathname;
      window.history.replaceState({}, document.title, baseUrl + '#/');
      // 跳转到首页
      this.$router.push('/');
    },
    getDingTalkCode(){
      if(this.isDinglogin){
        return false
      }
      this.isDinglogin = true;
      this.isScanCode = true
      var url = window.location.origin + window.location.pathname;
      let obj = {successUrl:url}
      var retry = new Promise(function (resolve, reject) {
        GetDingTalkCode(obj).then(res => {
            resolve(res)
        }).catch(err => {
            reject(err)
        })
      });
      retry.then(data => {
        if(data.data.statusCode == 200){
          this.isDinglogin = false;
          let url = data.data.headers.find(item => item.key == 'FORCE_REDIRECT')?.value[0]
          this.isScanCodeImg = false
          this.showImg(url)
        }
      }).catch(error => {
        this.isDinglogin = false;
        this.$alert(error)
      });
      
    },
    showImg(url){
      var goto = encodeURIComponent(url)
      this.$nextTick(() => {
        var obj = DDLogin({
          id:"login_container",//这里需要你在自己的页面定义一个HTML标签并设置id，例如<div id="login_container"></div>或<span id="login_container"></span>
          goto: goto, //请参考注释里的方式
          style: "border:none;background-color:#FFFFFF;padding:0px;",
          width : "300",
          height: "360"
        });
      });
        // 显示 login_container
        document.getElementById("login_container").style.display = "block";
    },
    handleMessage(event) {
      var origin = event.origin;
      if( origin == "https://login.dingtalk.com" ) { //判断是否来自ddLogin扫码事件。
        var loginTmpCode = event.data; 
        //获取到loginTmpCode后就可以在这里构造跳转链接进行跳转了
        let aa = "https://oapi.dingtalk.com/connect/oauth2/sns_authorize?appid=SuiteKey&response_type=code&scope=snsapi_login&state=STATE&redirect_uri=REDIRECT_URI&loginTmpCode=" + loginTmpCode
        window.location.replace(aa)
      }
    },
    // 给数组分组
    group(arr, size) {
      if (arr.length <= size) {
        return [arr]
      }
      return [arr.slice(0, size)].concat(this.group(arr.slice(size), size))
    },

    // 检查是否需要自动显示管理员列表
    async checkAutoShowAdminList() {
      try {
        // 首先检查是否有钉钉登录数据
        const dingLoginData = sessionStorage.getItem('dingLoginData');
        
        if (dingLoginData) {
          // 有钉钉数据，直接使用钉钉管理员列表
          this.dingLoginData = JSON.parse(dingLoginData);
          this.themeMenuId = this.dingLoginData.themeMenuId;
          
          if (this.dingLoginData.adminList && this.dingLoginData.adminList.length > 0) {
            const adminList = this.dingLoginData.adminList;
            
            // 设置显示状态
            this.isScanCode = true;
            this.isScanCodeImg = true;
            this.adminListGroup = this.group(adminList, 3);
            
            // 如果只有一个管理员，可以自动登录或显示选择界面
            if (adminList.length === 1) {
              // 只有一个管理员时，直接登录
              await this.adminDirectLogin(adminList[0]);
            }
          }
        }
        // 没有钉钉数据时，显示默认登录页面即可
      } catch (error) {
        // 如果获取失败，保持默认的账号密码登录界面
      }
    },
    // 执行钉钉登录
    async performDingLogin(admin) {
      if (this.isDinglogin) {
        return false;
      }
      
      this.isDinglogin = true;
      let userAgent = nameBrowser();
      let obj = {
        code: this.dingLoginData.code,
        adminId: admin.id,
        userAgent: userAgent
      };
      
      try {
        let res = await DingLogin(obj);
        if (res.status === 200 && res?.data?.code == 1 && res?.data?.result?.access_token) {
          this.isDinglogin = false;
          const data = res.data.result;
          let expiresTime = data.expires_in + new Date() / 1000;
          const token = {
            AccessToken: data.access_token,
            AccessExpiresIn: expiresTime,
            RefreshToken: data.refresh_token,
          };
          this.$store.commit("saveTokenStorage", token);
          this.getInfo(token);
        } else {
          this.isDinglogin = false;
          this.$confirm(res.data.message || '登录失败', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            var url = window.location.origin + window.location.pathname;
            window.location.replace(url);
          }).catch(() => {
            var url = window.location.origin + window.location.pathname;
            window.location.replace(url);
          });
        }
      } catch (error) {
        this.isDinglogin = false;
        // 钉钉登录失败时的错误处理
      }
    },
    displaySelectAccount(e) {
      this.showSelectAccount = !this.showSelectAccount;
      e.currentTarget.blur();
    },
    handleSelectAccount(id) {
      this.showSelectAccount = !this.showSelectAccount;
      this.RetrievePassword.id = id;
      this.currentSelectUser = this.usersAccount.find(item => item.id === id).name;
    },
    // 用户名请求时是否登录过
    async handleBlur(){
    if(this.account=="") return
      this.isCheck = true
      let res = await IsReLoginFromUserName(this.account)
      if(res.data.code == 1 ){
        this.isShowCode = false
      }else if(res.data.code == 2 ){
        this.isShowCode = false
        this.$alert(res.data.message)
      }
      else {
        this.isShowCode = true
        // this.$alert(res.data.message)
      }
    },
    show() {
      this.isShow = !this.isShow;
    },
    handleCommand(code) {
      this.code = code;
      this.isShow = false;
    },
    losePassword() {
      this.retrieve = true;
    },
    // 返回登录页
    clickNext2() {
      this.retrieve = false;
      this.next = 1;
      this.isAdminList = false;
      this.tableData = [];
      this.radio = null;
      this.RetrievePassword.VerificationCode = "";
      this.RetrievePassword.id = null;
      this.RetrievePassword.passWord = null;
    },
    // 提交
    clickNext1(formName) {
      this.$refs[formName].validate((valid) => {
        if (!valid) {
          return false;
        } else {
          this.getNext1(formName);
        }
      });
    },
    async getNext1() {
      if(!this.isClickCode2){
        this.$message.error({ message: "请获取验证码！", type: "warning" });
        return
      }
      this.disabled = true;
      var obj = {
        passWord: this.RetrievePassword.passWord,
        telPhone: this.RetrievePassword.telPhone,
        code: this.RetrievePassword.VerificationCode,
        id: this.RetrievePassword.id,
      };
      const res = await ResetPassword(obj);
      this.disabled = false;
      if (res.status == 400) {
        this.$alert("验证码错误");
        return;
      }
      if (res.data.code == 0) {
        this.$alert(res.data.message);
        return;
      }
      this.$alert("密码重置成功，请使用新密码重新登录！");
      this.retrieve = false;
      this.RetrievePassword.id = null;
      this.next = 1;
      this.isAdminList = false;
      this.tableData = [];
      this.radio = null;
      this.RetrievePassword = {
        telPhone: "",
        VerificationCode: "",
        id: null,
        passWord: null,
      };
    },
    // 验证码
    async clickValidation(value, formName) {
      if (this.code != "+86") {
        this.$message({
          message: "请选择正确的区号",
          type: "warning",
        });
        return false;
      }
      this.$refs[formName].validateField("telPhone", async (valid) => {
        if (!valid) {
          this.getClickValidation(value);
        } else {
          return false;
        }
      });
    },
    // 登录验证码
    async clickLoginValidation() {
      this.isClickCode1 = true
      if (!this.account) {
        this.$alert("请先输入用户名");
        return;
      } else {
        await this.$confirm(
          `系统将向当前登陆帐号[${this.account}]关联的手机号发送短信验证码,请确定帐号是否有误,发送短信验证码后将不能修改当前登陆的帐号!!`,
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }
        )
          .then(async () => {
            this.loginCode = true;
            this.loginCodeDisabled = true;
            let loginCodeRes = await SendMsgTelResponseTo(this.account);
            if (loginCodeRes.data.code == 1) {
              this.$confirm(loginCodeRes.data.message, "", {
                confirmButtonText: "我知道了",
                showCancelButton: false,
              });
              this.telDisable = true;
              this.loginSendSuccess = true;
              const TIME_COUNT = 60;
              if (!this.timerLogin) {
                this.loginCount = TIME_COUNT;
                this.loginSendSuccess = true;
                this.timerLogin = setInterval(() => {
                  if (this.loginCount > 0 && this.loginCount <= TIME_COUNT) {
                    this.loginCount--;
                  } else {
                    this.loginSendSuccess = false;
                    clearInterval(this.timerLogin);
                    this.timerLogin = null;
                  }
                }, 1000);
              }
            } else {
              this.telDisable = false;
              this.$alert(loginCodeRes.data.message);
            }
            this.loginCodeDisabled = false;
          })
          .catch(() => {
            this.$message.info("已取消");
            this.loginCodeDisabled = false;
          });
      }
    },
    // 获取验证码
    async getClickValidation(value) {
      this.isClickCode2 = true
      this.codeDisabled = true;
      var res = await GetCodeByTelPhone(value);
      var res1 = await GetAdminListForWeb(value);
      this.codeDisabled = false;
      if (res.data.code == 1) {
        this.SendSuccess = true;
        this.$message({
          message: res.data.message,
          type: "success",
        });
        this.isDisableRetrieveTel = true
        const TIME_COUNT = 60;
        if (!this.timer) {
          this.count = TIME_COUNT;
          this.SendSuccess = true;
          this.timer = setInterval(() => {
            if (this.count > 0 && this.count <= TIME_COUNT) {
              this.count--;
            } else {
              this.isDisableRetrieveTel = false
              this.isMultiAccountUser = false
              this.usersAccount = []
              this.currentSelectUser = ''
              this.SendSuccess = false;
              clearInterval(this.timer);
              this.timer = null;
            }
          }, 1000);
        }
      } else {
        this.$alert(res.message);
      }
      if (res1.data.code == 1) {
        if(res1.data.result.length > 1){
          this.isMultiAccountUser = true
          this.usersAccount = res1.data.result
        } else if(res1.data.result.length == 1) {
          this.isMultiAccountUser = false
          this.RetrievePassword.id = res1.data.result[0].id;
        }
       
      }
    },
    // 点击回车键登录
    keyDown(e) {
      if (this.retrieve) return;
      if (this.isSubmitDisabled) return;
      // 回车则执行登录方法 enter键的ASCII是13
      if (e.keyCode == 13) {
        this.submitClick(); // 定义的登录方法
      }
    },
    // 提交登录
    async submitClick() {
      if(!this.isCheck){
        this.handleBlur()
        return
      }
      if(!this.isClickCode1 && this.isShowCode){
        this.$message.error({ message: "请获取登录验证码！", type: "warning" });
        return
      }
      if (!this.account || (!this.password&&!this.isShowCode) || (!this.loginVerificationCode && this.isShowCode)) return;
      this.isClickLogin = true;
      const account = this.account;
      const password = this.password;
      await logIn(account, password, this.loginVerificationCode).then((res) => {
        if (res.status === 200 && res?.data?.code == 1 && res?.data?.result?.access_token) {
          const data = res.data.result;
          let expiresTime = data.expires_in + new Date() / 1000;
          const token = {
            AccessToken: data.access_token,
            AccessExpiresIn: expiresTime,
            RefreshToken: data.refresh_token,
          };
          this.$store.commit("saveTokenStorage", token);
          this.getInfo(token);
        } else {
          this.isClickLogin = false;
          this.$alert(res.data.message || '登录失败');
        }
      }).finally(() => {
         this.isClickLogin = false;
           });
    },
    async getInfo(token) {
      let AdminCache;
      await loginRoleInformation().then((result1) => {
        if (result1.code !== 0) {
          AdminCache = result1.result;
          // 存储主题色
          const webStyle = JSON.parse(result1.result.webStyle);
          let ThemeColorBGR = hexToRgb(webStyle.ThemeColor);
          webStyle.ThemeColorBGR = ThemeColorBGR;
          result1.result.webStyle = JSON.stringify(webStyle);
          let style;
          if (result1.result && result1.result.webStyle) {
            style = Object.assign(JSON.parse(result1.result.webStyle), defaultColor);
          } else {
            style = defaultThemeStyle;
          }
          // 存储主题色
          this.$store.commit("changeThemeColor", JSON.stringify(style));
          sessionStorage.setItem("themeStyle", JSON.stringify(style));
          document.title = this.allConfigAll.projectName;
          // 存储信息 重要！
          saveloginInfo(token, AdminCache, this.allConfigAll, AdminCache);
          const nowTime = new Date().getTime();
          const passwordExpiredTime = new Date(AdminCache.passwordExpiredTime).getTime();
          if (
            AdminCache.passwordExpiredTime &&
            (nowTime > passwordExpiredTime ||
              passwordExpiredTime - nowTime <= 2 * 24 * 60 * 60 * 1000)
          ) {
            this.timeTips(AdminCache.passwordExpiredTime);
          } else {
            // 登录成功提示
            this.$message({ message: "登录成功！", type: "success" });
            // 修改登录状态
            this.$store.commit("changeLoginState", true);
            // 存储登录状态localStorage
            sessionStorage.setItem("isLogin", true);
            
            // 检查是否有需要保留的URL参数或钉钉登录数据
            this.handlePostLoginRedirect();
          }
          //更换主题色
          this.getColorData(style);
        } else {
          AdminCache = false;
          this.$message.error({ message: "登录失败！", type: "success" });
          this.isClickLogin = false;
          this.isDinglogin = false;
        }
        //
      });
    },
    
    // 处理登录后的跳转逻辑
    handlePostLoginRedirect() {
      // 检查当前URL是否有需要保留的参数
      const currentUrl = new URL(window.location.href);
      const urlParams = currentUrl.searchParams;
      
      // 检查是否有钉钉登录相关参数
      const fromDing = urlParams.get('fromDing');
      const themenuid = urlParams.get('themenuid');
      
      let dingLoginData = null;
      
      // 优先使用URL参数中的钉钉登录信息
      if (fromDing === 'true' && themenuid) {
        dingLoginData = {
          fromDingLogin: true,
          themeMenuId: themenuid
        };
      } else if (this.dingLoginData && this.dingLoginData.fromDingLogin && this.dingLoginData.themeMenuId) {
        // 如果URL中没有，则使用组件属性中的钉钉登录数据
        dingLoginData = this.dingLoginData;
      }
      
      if (dingLoginData) {
        // 保存钉钉登录数据到sessionStorage
        sessionStorage.setItem('dingLoginData', JSON.stringify(dingLoginData));
        
        // 使用window.location.replace跳转到首页，清除URL中的code参数
        const baseUrl = window.location.origin + window.location.pathname;
        window.location.replace(baseUrl + '#/');
      } else {
        if(this.largeScreenPath && this.isLargeScreen == 'true'){
      // 检查是否来自大屏页面
        this.toLargeScreen()
        return;
      }
        // 普通登录，直接跳转到首页
        this.$router.push({ path: '/' });
      }
    },
    
    // time tips
    timeTips(time) {
      this.$alert(
        `你的登陆密码将在[${time}]过期,请在PC电脑端后台的右上角菜单中重新设置新密码,确保登陆密码有效！`,
        "过期提示",
        {
          confirmButtonText: "确定",
          callback: (action) => {
            // 登录成功提示
            this.$message({ message: "登录成功！", type: "success" });
            // 修改登录状态
            this.$store.commit("changeLoginState", true);
            // 存储登录状态localStorage
            sessionStorage.setItem("isLogin", true);
          
            // 检查是否有需要保留的URL参数或钉钉登录数据
            this.handlePostLoginRedirect();
          },
        }
      );
    },
    //更换主题色
    async getColorData(style) {
      this.themeColorNew = style;
      this.setColor();
      this.postVersion(this.themeColorNew.ThemeColor);
    },
    // 获取角色主题，生成动态颜色样式
    setColor() {
      this.$nextTick(() => {
        document.querySelector("body").setAttribute(
          "style",
          `
          --ThemeColor: ${this.themeColorNew.ThemeColor || "#fd5252"};
          --ThemeColorBGR: ${this.themeColorNew.ThemeColorBGR || "253, 82, 82"};
          --SliderMenuColor: ${this.themeColorNew.SliderMenuColor || "#eef1f6"};
          --MenuFontColor: ${this.themeColorNew.MenuFontColor || "#333333"};
          --UnderlineColor: ${this.themeColorNew.UnderlineColor || "#48494b"};
          --HeadBgColor: ${this.themeColorNew.HeadBgColor || "#fd5252"};
          --HeadTextColor: ${this.themeColorNew.HeadTextColor || "#FFFFFF"};
          --Success: ${this.themeColorNew.Success || "#67C23A"};
          --Warning: ${this.themeColorNew.Warning || "#E6A23C"};
          --Danger: ${this.themeColorNew.Danger || "#F56C6C"};
          --Info: ${this.themeColorNew.Info || "#909399"};`
        );
      });
      this.$store.commit("changeThemeColor", JSON.stringify(this.themeColorNew));
    },
    //动态更新element-ui主题色 只需要给一个主题色
    async postVersion(theme) {
      // 如果已有主题更新消息实例，先关闭它
      if (this.currentThemeMessageInstance && this.currentThemeMessageInstance.close) {
        this.currentThemeMessageInstance.close();
        this.currentThemeMessageInstance = null;
      }
      
      const oldVal = this.chalk ? theme : ORIGINAL_THEME;
      if (typeof theme !== "string") return;
      const themeCluster = this.getThemeCluster(theme.replace("#", ""));
      const originalCluster = this.getThemeCluster(oldVal.replace("#", ""));
      let messageInstance = null;
      try {
        messageInstance = this.$message({
          message: "更新主题中......",
          customClass: "theme-message",
          type: "success",
          duration: 0,
          iconClass: "el-icon-loading",
        });
        // 保存消息实例到组件属性中，便于管理
        this.currentThemeMessageInstance = messageInstance;
      } catch (error) {
        console.error('创建主题更新消息失败:', error);
        return;
      }
      const getHandler = (variable, id) => {
        return () => {
          const originalCluster = this.getThemeCluster(ORIGINAL_THEME.replace("#", ""));
          const newStyle = this.updateStyle(
            this[variable],
            originalCluster,
            themeCluster
          );
          let styleTag = document.getElementById(id);
          if (!styleTag) {
            styleTag = document.createElement("style");
            styleTag.setAttribute("id", id);
            document.head.appendChild(styleTag);
          }
          styleTag.innerText = newStyle;
        };
      };
      if (!this.chalk) {
        const url = `https://unpkg.zhimg.com/element-ui@${version}/lib/theme-chalk/index.css`;
        try {
          await this.getCSSString(url, "chalk");
        } catch (error) {
          // 加载element-ui主题CSS失败时的错误处理
          if (messageInstance && messageInstance.close) {
            messageInstance.close();
          }
          // 清理组件属性中的消息实例引用
          this.currentThemeMessageInstance = null;
          return;
        }
      }
      try {
        const chalkHandler = getHandler("chalk", "chalk-style");
        chalkHandler();
        const styles = [].slice.call(document.querySelectorAll("style")).filter((style) => {
          const text = style.innerText;
          return new RegExp(oldVal, "i").test(text) && !/Chalk Variables/.test(text);
        });
        styles.forEach((style) => {
          const { innerText } = style;
          if (typeof innerText !== "string") return;
          style.innerText = this.updateStyle(innerText, originalCluster, themeCluster);
        });
        this.$store.commit("changeGlobalTheme", JSON.stringify(theme));
      } catch (error) {
        // 主题更新过程中出现错误时的处理
      } finally {
        if (messageInstance && messageInstance.close) {
          messageInstance.close();
        }
        // 清理组件属性中的消息实例引用
        this.currentThemeMessageInstance = null;
      }
    },
    updateStyle(style, oldCluster, newCluster) {
      let newStyle = style;
      oldCluster.forEach((color, index) => {
        newStyle = newStyle.replace(new RegExp(color, "ig"), newCluster[index]);
      });
      return newStyle;
    },
    getCSSString(url, variable) {
      return new Promise((resolve) => {
        const xhr = new XMLHttpRequest();
        xhr.onreadystatechange = () => {
          if (xhr.readyState === 4 && xhr.status === 200) {
            this[variable] = xhr.responseText.replace(/@font-face{[^}]+}/, "");
            resolve();
          }
        };
        xhr.open("GET", url);
        xhr.send();
      });
    },
    getThemeCluster(theme) {
      const tintColor = (color, tint) => {
        let red = parseInt(color.slice(0, 2), 16);
        let green = parseInt(color.slice(2, 4), 16);
        let blue = parseInt(color.slice(4, 6), 16);
        if (tint === 0) {
          // when primary color is in its rgb space
          return [red, green, blue].join(",");
        } else {
          red += Math.round(tint * (255 - red));
          green += Math.round(tint * (255 - green));
          blue += Math.round(tint * (255 - blue));
          red = red.toString(16);
          green = green.toString(16);
          blue = blue.toString(16);
          return `#${red}${green}${blue}`;
        }
      };
      const shadeColor = (color, shade) => {
        let red = parseInt(color.slice(0, 2), 16);
        let green = parseInt(color.slice(2, 4), 16);
        let blue = parseInt(color.slice(4, 6), 16);
        red = Math.round((1 - shade) * red);
        green = Math.round((1 - shade) * green);
        blue = Math.round((1 - shade) * blue);
        red = red.toString(16);
        green = green.toString(16);
        blue = blue.toString(16);
        return `#${red}${green}${blue}`;
      };
      const clusters = [theme];
      for (let i = 0; i <= 9; i++) {
        clusters.push(tintColor(theme, Number((i / 10).toFixed(2))));
      }
      clusters.push(shadeColor(theme, 0.1));
      return clusters;
    },
    changeBlur(value){
      if((value && value.length < 8) ||
      !/^(?!^\d+$)(?!^[a-zA-Z]+$)[0-9a-zA-Z]{4,23}$/.test(value)){
        this.passwordShow=true
      }else{
        this.passwordShow=false
      }
    }
  },
  destroyed() {
    // 销毁事件
    window.removeEventListener("keydown", this.keyDown, false);
  },
};
</script>

<style scoped>
@import "//at.alicdn.com/t/c/font_3637944_3nknx95isjt.css";


:deep() .select-user-input .el-input__inner { 
  cursor: pointer!important;;
}
/* 在线链接服务仅供平台体验和调试使用，平台不承诺服务的稳定性，企业客户需下载字体包自行发布使用并做好备份。 */
.login_index {
  width: 100%;
  height: 100%;
  background: url("../assets/images/logo_index.png")
    no-repeat;
  background-size: 100% 1080px;
  /* background-color: #b8e5f8; */
  position: relative;
  background-position-y: -30px;
}
.account_parent {
  margin-right: 5px;
   display:flex;
   align-items: center;
   justify-content: space-between;
   position: relative;
}
.account_child {
  width:100%;
  display:flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
}
.center {
  position: absolute;
  width: 80%;
  top: 48%;
  left: 50%;
  transform: translate(-50%, -42%);
  display: flex;
  justify-content: space-around;
  align-items: center;
}

.c_left {
  font-size: 30px;
  color: #fff;
}

.c_right {
  position: relative;
  background-color: #fff;
  width: 580px;
  min-height: 560px;
  margin: auto;
  padding: 54px 83px 0;
  box-shadow: 0px 2px 40px 0px rgba(0, 0, 0, 0.15);
  border-radius: 30px;
}
.c_right{
  padding: 54px 73px 0;
}
.l_t_btn{
  position: absolute;
  top: 0;
  left: 0;
  width: 72px;
  height: 72px;
}
.admin_box{
  width: 446px;
  height: 326px;
  margin: 0 auto;
  margin-top: 29px;
  overflow: auto;
}
.admin_box_h{
  display: flex;
  justify-content: space-between;
  width: 100%;
  height: 130px;
  margin-bottom: 33px;
}
.pa_89{
  padding: 0 64px;
  box-sizing: border-box;
}
.pa_178{
  padding: 0 165px;
  box-sizing: border-box;
}
.admin_list{
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 115px;
  height: 130px;

}
.admin_list_img{
  width: 71px;
  height: 71px;
  border-radius: 50%;
}
.admin_img_box{
  width: 71px;
  height: 71px;
  line-height: 71px;
  text-align: center;
  color: #fff;
  border-radius: 50%;
  background-color: #007fff;
  font-size: 18px;
}
.admin_list_name{
  margin-top: 5px;
  font-weight: 600;
  font-size: 18px;
  color: #323233;
  width: 115px;
  overflow:hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  text-align: center;
}
.admin_list_role{
  width: 115px;
  overflow:hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  text-align: center;
  margin-top: 5px;
  font-weight: 400;
  font-size: 16px;
  color: #323233;
}
.login_container{
  width: 300px;
  height: 330px;
  margin: 0 auto;
  margin-top: -20px;
}
.code_tip2{
  width: 100%;
  text-align: center;
  margin-top: 44px;
  font-size: 14px;
  color: #323233;
}
.code_tip_span{
  color: #007fff;
}

.code_tip{
  /* margin-top: 33px; */
  width: 100%;
  text-align: center;
  font-weight: 400;
  font-size: 14px;
  color: #B3B3B3;
}

.login_title {
  text-align: center;
  font-size: 34px;
  font-weight: 700;
  color: #4f430a;
  margin-bottom: 10px;
}

.login_title_english {
  font-size: 16px;
  color: #666666;
  text-align: center;
  padding-bottom: 50px;
  font-family: "AlibabaPuHuiTi_2_65_Medium";
}

.input {
  text-align: center;
  width: 100%;
  height: 52px;
  line-height: 58px;
  margin-bottom: 35px;
  position: relative;
  border: 1px solid #e2e5f0;
  border-radius: 10px;
}
.item_popover {
  position: absolute;
  top: -3px;
  right: -72px;
}
.item_popover .el-button--medium {
  width: 70px;
  height: 50px;
}
.item_btn {
  margin-left: -12px;
}
.input >>> .el-input__inner::-webkit-input-placeholder {
  color: #e5e5e5;
  font-weight: 400;
}

#form-sure >>> .el-input__inner::-webkit-input-placeholder {
  font-weight: 400;
  color: #e5e5e5;
}

.error-tip {
  position: absolute;
  left: 0;
  bottom: -45px;
  color: #f56c6c;
  font-size: 12px;
}

.flex {
  display: flex;
  align-content: center;
}

.iconfont {
  width: 60px;
  height: 40px;
  line-height: 40px;
}

.icon-yonghu {
  color: #a6acb2;
}

.form-input {
  width: 100%;
  /* margin-right: 50px; */
  position: absolute;
  left: 0px;
  bottom: 0;
  font-size: 16px;
  line-height: 50px;
}

.icon-suo {
  color: #a6acb2;
}

.oth-switch {
  margin-top: 20px;
  color: #888;
  /* float: right; */
  font-size: 16px;
  font-family: "AlibabaPuHuiTi_2_75_SemiBold";
  color: #ff9f1d;
  text-align: center;
}

@font-face {
  font-family: "AlibabaPuHuiTi_2_65_Medium";
  src: url("https://huihangedu-test.oss-cn-hangzhou.aliyuncs.com/5152e300-4d1b-4cbf-bf80-c69a80b9966a.otf")
    format("Opentype");
}

@font-face {
  font-family: "AlibabaPuHuiTi_2_75_SemiBold";
  src: url("https://huihangedu-test.oss-cn-hangzhou.aliyuncs.com/2f6d6bda-3589-4e93-b1a4-2bcbb454d530.otf")
    format("Opentype");
}

.submit-btn {
  margin-top: 18px;
  width: 100%;
  height: 52px;
  background: #ffd71d !important;
  border-radius: 8px;
  text-align: center;
  border: none;
  font-size: 18px;
  color: #333333 !important;
  font-family: "AlibabaPuHuiTi_2_65_Medium";
}

.submit-btn > .is-disabled {
  background: rgba(255, 215, 29, 0.5) !important;
}

.submit-btn:hover {
  background: rgba(255, 215, 29, 0.5) !important;
}

.disable-color.el-input--suffix >>> .el-input__inner {
  color: #999;
}

.el-input--suffix >>> .el-input__inner {
  border: none !important;
  font-size: 18px;
  font-family: "AlibabaPuHuiTi_2_65_Medium";
  color: #000000;
  font-weight: 400;
  height: 25px;
}

.el-input--suffix >>> .el-input__clear {
  font-size: 24px;
  line-height: 25px;
}

/* 忘记密码 */
.title {
  height: 150px;
  line-height: 150px;
  justify-content: space-between;
  box-sizing: border-box;
}

.lose-title {
  font-size: 24px;
  color: #409eff;
}

.lose-titleLogin {
  color: #b6b6bc;
  text-align: center;
  font-size: 16px;
  font-family: "AlibabaPuHuiTi_2_75_SemiBold";
  color: #ff9f1d;
  margin-top: 18px;
}

#form-sure >>> .el-input {
  width: 250px;
  position: absolute;
}

#form-sure >>> .el-input__inner {
  border: none !important;
  background: #fff;
  padding-right: 10px !important;
  width: 240px;
  font-size: 14px;
}

#form-sure >>> .el-input__suffix-inner {
  display: flex;
  align-items: center;
}

#form-sure >>> .el-input__suffix {
  display: flex;
}

#form-sure >>> .el-form-item__content {
  line-height: 25px;
}

#form-sure >>> .el-form-item__label {
  /* color: #333333; */
  font-weight: 400;
}

.input-box {
  width: 91%;
  color: #333333;
  font-weight: 800;
  margin-bottom: 30px;
  border-radius: 8px;
  border: 1px solid #e5e5e5;
  padding: 10px 15px 10px 20px;
  position: relative;
  box-sizing: content-box;
  height: 25px;
  line-height: 25px;
}
.select-user {
  position: absolute;
  top: 38px;
  left: -21px;
  transform-origin: center top;
  z-index: 3002;
  border:1px solid #e5e5e5;
  height: auto;
  overflow-y: auto;
  background: #fff;
  cursor: pointer;
  border-radius: 8px;
  width: 415px;
  color: #999999;
  font-size: 18px;
}
.user-list.list-item {
  width: 100%;
  height: 50px;
  line-height: 50px;
  border-radius: 8px;
  padding: 10px 15px 10px 20px;
  color: #999999;
  font-size: 18px;
}
.user-list:hover {
  background-color: rgb(254,251,234);
}
.input-box >>> .el-form-item__label {
  border-right: 1px solid #e5e5e5;
  font-size: 18px;
  font-family: "AlibabaPuHuiTi_2_65_Medium";
  color: #999999;
  height: 25px;
  line-height: 25px;
}

.input-box >>> .el-form-item__error {
  margin-top: 42px;
  white-space: nowrap;
}

.lose_english {
  padding-bottom: 25px;
}

.adress-box {
  position: absolute;
  left: -68px;
  top: 0px;
  z-index: 999;
}

.adress {
  /* width: 80px;
    height: 35px; */
  position: relative;
  font-size: 18px;
  font-family: "AlibabaPuHuiTi_2_65_Medium";
  color: #999999;
  /* border-right: 1px solid #e8ebf2; */
  font-weight: 400;
}

ul {
  position: absolute;
  top: 30px;
  left: -80px;
  transform-origin: center top;
  z-index: 3002;
  border: 1px solid #ccc;
  height: 300px;
  overflow-y: auto;
  background: #fff;
  cursor: pointer;
}

li {
  line-height: 30px;
  padding: 0 17px;
  font-size: 14px;
}

.submit-sureBtn {
  margin-top: 10px;
  width: 100%;
  height: 52px;
  background: #ffd71d;
  border-radius: 8px;
  /* font-size: 16px; */
  text-align: center;
  border: none;
  font-size: 18px;
  font-family: "AlibabaPuHuiTi_2_65_Medium";
  color: #333333;
}

.submit-sureBtn.is-disabled {
  background: rgba(255, 215, 29, 0.5);
}

.submit-sureBtn.is-disabled:hover {
  background: rgba(255, 215, 29, 0.5);
}

.lose_right {
  /* padding-top: 0; */
  padding-bottom: 24px;
}

.lose_right >>> .el-form {
  margin-bottom: 0;
}

.validation {
  padding: 0;
  font-family: AlibabaPuHuiTi_2_65_Medium;
  font-size: 14px;
}

@keyframes worng {
  0% {
    transform: translateX(0%);
  }

  25% {
    transform: translateX(-10%);
  }

  50% {
    transform: translateX(0%);
  }

  75% {
    transform: translateX(10%);
  }

  100% {
    transform: translateX(0%);
  }
}
/* 在 input 元素中使用 text 代替 password 防止浏览器记住密码，这种字体下所有的字符都显示为 圆点 */
::v-deep() .input_password input{
	-webkit-text-security: disc;
}

</style>
<style>
.confirmButton {
  background: #ffd71d;
  border: none;
}

.confirmButton:hover {
  background: rgba(255, 215, 29, 0.5);
}

.confirmButton:active {
  background: #ffd71d;
}

.confirmButton:focus {
  background: #ffd71d;
}

</style>
